import script from "./PasskeyEnrollment.vue?vue&type=script&setup=true&lang=js"
export * from "./PasskeyEnrollment.vue?vue&type=script&setup=true&lang=js"

import "./PasskeyEnrollment.vue?vue&type=style&index=0&id=20072554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20072554"]])

export default __exports__